import type { RecentItem } from '../../hooks/useRecentItems';

function formatRelativeTime(ts: number): string {
  const diff = Date.now() - ts;
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
}

export function RecentMattersMenu({
  items,
  onClearAll,
  onSelect,
}: {
  items: RecentItem[];
  onClearAll: () => void;
  onSelect: (item: RecentItem) => void;
}) {
  return (
    <div style={{
      position: 'absolute',
      top: 'calc(100% + 6px)',
      right: 0,
      background: 'var(--card)',
      borderRadius: 'var(--radius-md)',
      boxShadow: 'var(--shadow-lg)',
      border: '1px solid var(--border)',
      minWidth: 280,
      zIndex: 200,
      overflow: 'hidden',
    }}>
      <div style={{ padding: '0.5rem 0.75rem', fontSize: '0.65rem', color: 'var(--text-muted)', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Recent Matters</span>
        {items.length > 0 && (
          <button
            onClick={onClearAll}
            style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.65rem', color: 'var(--text-muted)', padding: 0 }}
            onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--primary)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--text-muted)'; }}
          >
            Clear All
          </button>
        )}
      </div>
      {items.length === 0 ? (
        <div style={{ padding: '0.75rem', color: 'var(--text-muted)', fontSize: '0.8rem' }}>No recent matters</div>
      ) : (
        items.map((item) => (
          <div
            key={item.id}
            onClick={() => onSelect(item)}
            style={{
              padding: '0.5rem 0.75rem',
              cursor: 'pointer',
              borderBottom: '1px solid var(--border-light)',
              fontSize: '0.8rem',
              transition: 'background 0.1s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'var(--bg)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
              {item.stageColor && (
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: item.stageColor, flexShrink: 0 }} />
              )}
              <span style={{ fontWeight: 600, color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.title}</span>
            </div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', display: 'flex', justifyContent: 'space-between' }}>
              <span>M-{item.id}{item.stageName ? ` \u00B7 ${item.stageName}` : ''}</span>
              <span>{formatRelativeTime(item.viewedAt)}</span>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
